module.exports = __webpack_public_path__ + "static/img/YouTube_Logo_2017.468980b0.svg";